/* esm.sh - applesauce-common@5.2.0/dist/helpers/zap */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/zap.mjs";
